(() => {
  const SELECTOR = '.product-details [data-image-gallery-main]';
  const INDICATOR_CLASS = 'starumi-mobile-media-indicator';
  const BUTTON_CLASS = 'starumi-mobile-media-indicator__button';
  const EVENT_NAMESPACE = '.starumiMobileMediaIndicator';

  const imageIcon = `
    <svg class="starumi-mobile-media-indicator__shape" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
      <circle cx="6" cy="6" r="4.5"></circle>
    </svg>`;

  const videoIcon = `
    <svg class="starumi-mobile-media-indicator__shape" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
      <path d="M3.25 1.75 10 6l-6.75 4.25Z"></path>
    </svg>`;

  function isVideoSlide(slide) {
    return Boolean(
      slide.querySelector(
        '.productView-video, [data-youtube], [data-vimeo], [data-mp4], video'
      )
    );
  }

  function getSlides(gallery, slick) {
    if (slick && slick.$slides && slick.$slides.length) {
      return Array.from(slick.$slides);
    }

    return Array.from(
      gallery.querySelectorAll('.productView-image:not(.slick-cloned)')
    ).sort((a, b) => {
      const aIndex = Number(a.getAttribute('data-slick-index') || a.dataset.index || 0);
      const bIndex = Number(b.getAttribute('data-slick-index') || b.dataset.index || 0);
      return aIndex - bIndex;
    });
  }

  function updateIndicator(indicator, currentIndex, mediaCount) {
    if (!indicator || !mediaCount) return;

    const normalizedIndex =
      ((Number(currentIndex || 0) % mediaCount) + mediaCount) % mediaCount;

    indicator.querySelectorAll(`.${BUTTON_CLASS}`).forEach((button, index) => {
      if (index === normalizedIndex) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function buildIndicator(gallery, slick) {
    const imageWrapper = gallery.closest('.productView-image-wrapper');
    if (!imageWrapper) return null;

    const oldIndicator = imageWrapper.parentElement.querySelector(
      `:scope > .${INDICATOR_CLASS}`
    );
    if (oldIndicator) oldIndicator.remove();

    const slides = getSlides(gallery, slick);
    if (!slides.length) return null;

    const indicator = document.createElement('div');
    indicator.className = INDICATOR_CLASS;
    indicator.setAttribute('role', 'group');
    indicator.setAttribute('aria-label', 'Product media');

    slides.forEach((slide, index) => {
      const video = isVideoSlide(slide);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = BUTTON_CLASS;
      button.dataset.mediaIndex = String(index);
      button.setAttribute(
        'aria-label',
        `View ${video ? 'video' : 'image'} ${index + 1}`
      );
      button.innerHTML = video ? videoIcon : imageIcon;
      indicator.appendChild(button);
    });

    imageWrapper.insertAdjacentElement('afterend', indicator);
    updateIndicator(indicator, slick ? slick.currentSlide : 0, slides.length);
    return indicator;
  }

  function initializeGallery(gallery) {
    if (!gallery || gallery.dataset.starumiMediaIndicatorInitialized === 'true') {
      return;
    }

    const $ = window.jQuery;
    if (!$ || !$.fn || typeof $.fn.slick !== 'function') return;

    gallery.dataset.starumiMediaIndicatorInitialized = 'true';
    const $gallery = $(gallery);
    let indicator = null;

    const rebuild = (slick) => {
      indicator = buildIndicator(gallery, slick);
      if (!indicator) return;

      indicator.addEventListener('click', (event) => {
        const button = event.target.closest(`.${BUTTON_CLASS}`);
        if (!button || !indicator.contains(button)) return;

        const index = Number(button.dataset.mediaIndex);
        if (!Number.isInteger(index)) return;
        $gallery.slick('slickGoTo', index);
      });
    };

    $gallery
      .off(EVENT_NAMESPACE)
      .on(`init${EVENT_NAMESPACE}`, (event, slick) => {
        rebuild(slick);
      })
      .on(`reInit${EVENT_NAMESPACE}`, (event, slick) => {
        rebuild(slick);
      })
      .on(`afterChange${EVENT_NAMESPACE}`, (event, slick, currentSlide) => {
        if (!indicator || !indicator.isConnected) rebuild(slick);
        updateIndicator(indicator, currentSlide, slick.slideCount);

        const activeSlide = slick.$slides && slick.$slides.eq(currentSlide);
        if (!activeSlide || !activeSlide.length) return;

        // Ella may autoplay video slides after a change. Keep new video slides
        // paused until the customer explicitly presses the media control.
        activeSlide.find('video').each((index, video) => {
          video.muted = true;
          window.setTimeout(() => video.pause(), 0);
        });
        activeSlide.find('iframe').each((index, iframe) => {
          if (!iframe.contentWindow) return;
          window.setTimeout(() => {
            iframe.contentWindow.postMessage(
              JSON.stringify({ method: 'pause', value: 'true' }),
              '*'
            );
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
              '*'
            );
          }, 0);
        });
      })
      .on(`beforeChange${EVENT_NAMESPACE}`, (event, slick) => {
        const currentSlide = slick.$slides && slick.$slides.eq(slick.currentSlide);
        if (!currentSlide || !currentSlide.length) return;

        currentSlide.find('video').each((index, video) => video.pause());
        currentSlide.find('iframe').each((index, iframe) => {
          if (!iframe.contentWindow) return;
          iframe.contentWindow.postMessage(
            JSON.stringify({ method: 'pause', value: 'true' }),
            '*'
          );
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
            '*'
          );
        });
      });

    const existingSlick = gallery.slick;
    if (existingSlick && existingSlick.slideCount !== undefined) {
      rebuild(existingSlick);
    }
  }

  function initializeAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initializeGallery);
  }

  function start() {
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
